import { Breadcrumb, Button, Col, Row, Tag, Typography } from "antd";
import { HomeFilled, MailFilled, PhoneFilled, PushpinFilled } from "@ant-design/icons";

import { Description } from "../../../../shared-components/Components/Property/Description/web";
import { ImagenOptimizada } from "../../../../shared-components/Components/Image/web";
import { PhoneButton } from "../../../../shared-components/Components/RealEstateAgent/PhoneButton/web";
import React from "react";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import { useTheme } from "../../../../shared-components/Styles/ThemeHook";
import { ListingCard } from "shared-components/ViewFragments/SearchPage/ListingCard";
import { ArrowRightIcon } from "shared-components/Components/CustomIcons/ArrowRightIcon/web";

const { Title, Text } = Typography;

export const BannerTopCover = ({ inmob }) => {
	const { img_cover, color, logo_v2, name } = inmob;

	return (
		<Row className="perfil-banner-container">
			<Col className="img-cover">
				<ImagenOptimizada alt={name} src={img_cover} />
			</Col>
			<Col className="overlay" style={{ background: color }}></Col>
			<Col className="perfil-logo" style={{ background: color }}>
				<ImagenOptimizada alt={name} src={logo_v2} />
			</Col>
		</Row>
	);
};

export const BannerAffix = ({ inmob }) => {
	const { theme } = useTheme();
	const screen = useBreakpoint();
	const { logo_v2, font_color } = inmob;
	const name = inmob.name.split("-").join(" ");
	const email = inmob.subsidiaries.map(e => e)[0].email;

	return (
		<Row className="perfil-affix-row" gutter={theme.spacing.xlSpacing}>
			{screen.xs && (
				<Col className="perfil-logo">
					<ImagenOptimizada alt={name} src={logo_v2} />
				</Col>
			)}
			<Col className="perfil-info">
				<Col className="verified ">
					<Tag color={"default"} className="verified-tag">
						{"Inmobiliaria Verificada"}
					</Tag>
				</Col>
				{!screen.xs && (
					<Title style={{ color: font_color }} className="property-title" level={1}>
						{`Inmobiliaria ${name}`}
					</Title>
				)}
			</Col>
			<Col className="button-consultar">
				<Button
					href={`mailto:${email}?subject=Consulta a ${name} - InfoCasas`}
					type="primary"
					block>
					{"Consultar"}
				</Button>
			</Col>
		</Row>
	);
};

export const PerfilBreadcrumb = ({ inmob }) => {
	const name = inmob.name.split("-").join(" ");

	return (
		<Breadcrumb separator="" className="breadcrumb-container">
			<Breadcrumb.Item>
				{"Estás en"}
				{": "}
			</Breadcrumb.Item>
			<Breadcrumb.Item href="/">{"InfoCasas"}</Breadcrumb.Item>
			<Breadcrumb.Separator>
				<ArrowRightIcon />
			</Breadcrumb.Separator>
			<Breadcrumb.Item href="/inmobiliarias">{"Inmobiliarias"}</Breadcrumb.Item>
			<Breadcrumb.Separator>
				<ArrowRightIcon />
			</Breadcrumb.Separator>
			<Breadcrumb.Item>{name}</Breadcrumb.Item>
		</Breadcrumb>
	);
};

export const PerfilInfoInmob = ({ inmob }) => {
	const { theme } = useTheme();
	const { img_description } = inmob;
	const name = inmob.name.split("-").join(" ");
	const descriptions = inmob.description.split(".");

	return (
		<Row gutter={[0, theme.spacing.xlSpacing]} justify="space-between" align="middle">
			<Col xs={{ span: 24, order: 2 }} md={{ span: 8, order: 1 }} className="inmob-left">
				<ImagenOptimizada alt={name} src={img_description} />
			</Col>
			<Col xs={{ span: 24, order: 1 }} md={{ span: 15, order: 2 }} className="inmob-right">
				<Title className="property-title" level={1}>
					{`Acerca de ${name}`}
				</Title>
				{descriptions?.map(
					(desc, i) =>
						desc.length > 0 && (
							<Description
								description={desc + "."}
								hideInformation={false}
								cleanHtml
							/>
						)
				)}
			</Col>
		</Row>
	);
};

export const PerfilSubsidiary = ({ inmob }) => {
	const { subsidiaries, color, font_color, id, name, masked_phone } = inmob;

	return (
		<React.Fragment>
			<Title level={2}>{"Sucursales"}</Title>
			<div className="perfil-subsidiaries">
				{subsidiaries.map((subsidiary, i) => (
					<div
						className="subsidiary"
						key={"subsidiary_" + i}
						style={
							subsidiaries.length == 1
								? { flexBasis: "50%" }
								: { flexBasis: "calc(50% - 8px)" }
						}>
						<div
							className="icon"
							style={{
								background: color,
								color: font_color,
							}}>
							<HomeFilled />
						</div>
						<div className="info-inmob">
							<Title level={4}>{subsidiary.name}</Title>
							{subsidiary.address && (
								<div className="locations">
									<PushpinFilled />
									<Text>{subsidiary.address}</Text>
								</div>
							)}
							{subsidiary.email && (
								<div className="emails">
									<MailFilled />
									<Text>{subsidiary.email}</Text>
								</div>
							)}
							<div className="phones">
								<PhoneFilled />
								<PhoneButton
									owner_id={id}
									owner_name={name}
									masked_phone={masked_phone}
									isWpp={false}
									ui_style="text"
								/>
							</div>
						</div>
					</div>
				))}
			</div>
		</React.Fragment>
	);
};

export const PerfilProperties = ({ inmob }) => {
	const { theme } = useTheme();
	const { inmoPropsLink } = inmob;
	const properties = inmob.properties.data.map(e => e);

	return <>
		<h2>Propiedades Recientes</h2>
		<div
			style={{
					display: 'flex',
					flexDirection: 'row',
					flexWrap: 'wrap',
					gap: '10px',
					alignItems: 'flex-start',
					marginBottom:'20px'
			}}
			className="perfil-properties-card"
		>
			{properties?.map( (prop, i) => 
				<ListingCard data={{
					id: prop?.id,
					legacy_propID: prop?.id,
					bedrooms: prop?.bedrooms,
					bathrooms: prop?.bathrooms,
					guests: prop?.guests,
					isExternal: prop?.isExternal,
					rooms: prop?.rooms,
					img: prop?.img,
					neighborhood: prop?.neighborhood?.name,
					estate: prop?.estate?.name,
					price: prop?.price?.amount,
					currency: prop?.price?.currency?.name,
					link: "/"+prop?.link,
					title: prop?.title
				}} key={i}/>
			)}
		</div>
		
		{inmoPropsLink && (
			<Button href={inmoPropsLink}>{"Ver todas las propiedades"}</Button>
		)}
	</>
	
};

export const PerfilButtonContacts = ({ inmob, contact }) => {
	const { theme } = useTheme();
	const name = inmob.name.split("-").join(" ");
	const email = inmob.subsidiaries.map(e => e)[0].email;

	return (
		<React.Fragment>
			<Title level={4} className="perfil-title-contact">
				{`Ponte en Contacto con ${name}`}
			</Title>
			<Row
				gutter={[theme.spacing.lgSpacing, theme.spacing.lgSpacing]}
				justify="space-between"
				align="middle"
				className="perfil-buttons">
				{contact.map((elem, i) => (
					<Col key={"contact_" + i} flex={"1"}>
						<Button
							href={`mailto:${email}?subject=${elem.nameHref} - ${name} - InfoCasas`}
							type="primary"
							block>
							{elem.title}
						</Button>
					</Col>
				))}
			</Row>
		</React.Fragment>
	);
};
